// extracted by mini-css-extract-plugin
module.exports = {"totalRefund":"_1pf13rPOxaLR","price":"_2GTVuXMytdnd","price__title":"hqzLIHbBKLrt","priceHeadTitle":"_2IgsBK6lM2Sl","dashedSeparator":"_3MGETQev0y_q"};